/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeploymentStepLogDto } from './DeploymentStepLogDto';
import {
    DeploymentStepLogDtoFromJSON,
    DeploymentStepLogDtoFromJSONTyped,
    DeploymentStepLogDtoToJSON,
} from './DeploymentStepLogDto';
import type { DeploymentSubStepDto } from './DeploymentSubStepDto';
import {
    DeploymentSubStepDtoFromJSON,
    DeploymentSubStepDtoFromJSONTyped,
    DeploymentSubStepDtoToJSON,
} from './DeploymentSubStepDto';

/**
 * 
 * @export
 * @interface DeploymentStepDto
 */
export interface DeploymentStepDto {
    /**
     * The ID of the resource within the service definition.
     * @type {string}
     * @memberof DeploymentStepDto
     */
    resourceId: string;
    /**
     * The display name of the resource.
     * @type {string}
     * @memberof DeploymentStepDto
     */
    resourceName: string;
    /**
     * Whether the resource is deployed or deleted in this step.
     * @type {string}
     * @memberof DeploymentStepDto
     */
    action: DeploymentStepDtoActionEnum;
    /**
     * The status of the step.
     * @type {string}
     * @memberof DeploymentStepDto
     */
    status: DeploymentStepDtoStatusEnum;
    /**
     * The current attempt, greater than one when the step has been retried.
     * @type {number}
     * @memberof DeploymentStepDto
     */
    attempt: number;
    /**
     * The maximum number of attempts.
     * @type {number}
     * @memberof DeploymentStepDto
     */
    maxAttempts: number;
    /**
     * The error of the last failed attempt.
     * @type {string}
     * @memberof DeploymentStepDto
     */
    error: string | null;
    /**
     * The sub-steps as reported by the worker.
     * @type {Array<DeploymentSubStepDto>}
     * @memberof DeploymentStepDto
     */
    subSteps: Array<DeploymentSubStepDto>;
    /**
     * The timestamped log lines reported outside any sub-step.
     * @type {Array<DeploymentStepLogDto>}
     * @memberof DeploymentStepDto
     */
    logs: Array<DeploymentStepLogDto>;
    /**
     * When the step was started.
     * @type {Date}
     * @memberof DeploymentStepDto
     */
    startedAt: Date | null;
    /**
     * When the step was completed or failed.
     * @type {Date}
     * @memberof DeploymentStepDto
     */
    completedAt: Date | null;
}


/**
 * @export
 */
export const DeploymentStepDtoActionEnum = {
    Deploy: 'Deploy',
    Delete: 'Delete'
} as const;
export type DeploymentStepDtoActionEnum = typeof DeploymentStepDtoActionEnum[keyof typeof DeploymentStepDtoActionEnum];

/**
 * @export
 */
export const DeploymentStepDtoStatusEnum = {
    Pending: 'Pending',
    Running: 'Running',
    Completed: 'Completed',
    Failed: 'Failed'
} as const;
export type DeploymentStepDtoStatusEnum = typeof DeploymentStepDtoStatusEnum[keyof typeof DeploymentStepDtoStatusEnum];


/**
 * Check if a given object implements the DeploymentStepDto interface.
 */
export function instanceOfDeploymentStepDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resourceId" in value;
    isInstance = isInstance && "resourceName" in value;
    isInstance = isInstance && "action" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "attempt" in value;
    isInstance = isInstance && "maxAttempts" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "subSteps" in value;
    isInstance = isInstance && "logs" in value;
    isInstance = isInstance && "startedAt" in value;
    isInstance = isInstance && "completedAt" in value;

    return isInstance;
}

export function DeploymentStepDtoFromJSON(json: any): DeploymentStepDto {
    return DeploymentStepDtoFromJSONTyped(json, false);
}

export function DeploymentStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentStepDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resourceId': json['resourceId'],
        'resourceName': json['resourceName'],
        'action': json['action'],
        'status': json['status'],
        'attempt': json['attempt'],
        'maxAttempts': json['maxAttempts'],
        'error': json['error'],
        'subSteps': ((json['subSteps'] as Array<any>).map(DeploymentSubStepDtoFromJSON)),
        'logs': ((json['logs'] as Array<any>).map(DeploymentStepLogDtoFromJSON)),
        'startedAt': (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': (json['completedAt'] === null ? null : new Date(json['completedAt'])),
    };
}

export function DeploymentStepDtoToJSON(value?: DeploymentStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resourceId': value.resourceId,
        'resourceName': value.resourceName,
        'action': value.action,
        'status': value.status,
        'attempt': value.attempt,
        'maxAttempts': value.maxAttempts,
        'error': value.error,
        'subSteps': ((value.subSteps as Array<any>).map(DeploymentSubStepDtoToJSON)),
        'logs': ((value.logs as Array<any>).map(DeploymentStepLogDtoToJSON)),
        'startedAt': (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': (value.completedAt === null ? null : value.completedAt.toISOString()),
    };
}

